// Order of import is important
import { $ } from '@@/bits/jquery'
import 'jquery-ui/ui/widgets/draggable'
import 'vendor/jquery.ui.touch-punch'
export { $ }
